// extracted by mini-css-extract-plugin
module.exports = {"container":"PaymodesFooter_healthgenom_container__2ElpV","title":"PaymodesFooter_healthgenom_title__1wFG5"};